export const toastMessage = {
  INTERNAL_SERVER_ERROR: "Ops, algo deu errado. Por favor tente mais tarde!",
  REQUESTING: "Aguarde um momento, ainda estamos concluindo uma ação.",
  PAGE_NOT_FOUND: "Esta página não foi encontrada!",
};
